export default {
  validation: {
    required: 'Đây là một câu hỏi bắt buộc',
    kana_format: '',
    email_format: 'Gõ vào @.lower:validation.variables.email',
    date_format: 'Gõ vào @.lower:validation.variables.date',
    number_format: 'Gõ vào @.lower:validation.variables.number',
    halfwidth_number_format: 'Chỉ nhập chữ số nửa chiều rộng',
    alphanumeric_format: 'Gõ vào @.lower:validation.variables.alphanumeric',
    postal_number_no_hyphen: 'Gõ vào @.lower:validation.variables.postal_number',
    postal_number_format: 'Gõ @:validation.variables.postal_number vào Không dùng dấu gạch nối',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: 'Gõ vào 6 ký tự trở lên',
    min_length: 'Gõ vào {length} 6 ký tự trở lên',
    max_length: 'Gõ vào {length} ký tự trở xuống',
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: 'Vui lòng nhập tối đa {digit} chữ số.',
    max_digit_with_item: 'Xin vui lòng nhập {item} trong vòng {digit} chữ số',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: 'Không được phép trả lời chỉ bằng dấu cách và/hoặc ngắt dòng.',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/địa chỉ email',
      email: 'địa chỉ email',
      password: 'Mật khẩu',
      kana: '',
      date: 'Ngày (ví dụ: 31/01/2023)',
      number: 'Số',
      alphanumeric: 'Chữ cái và số',
      postal_number: 'Mã bưu chính',
    },
  },
}
